import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import ColumnItemPlaceholderDropZone from './ColumnItemPlaceholderDropZone';
import Borders from './Borders';
import { blockType, sessionType } from '../../../../../../types';
import * as Styled from './styles';
import * as columnItemActions from '../../../../../../actions/columnItem';
import ElementIcon from './ElementIcon';
import * as modalActions from '../../../../../../actions/modals';
import getSurveyPermission from '../../../../../../common/getPermissions';
import { elementBorderColors } from '../../../../../../constants/styleRules/styleRules';
import handleKeyPress from '../../../../../../common/handleKeyPress';
import elementTypes from '../../../../../../constants/elementTypes';

let elementsArray = ['PARAGRAPH', 'IMAGE', 'BUTTON', 'SURVEY', 'VIDEO', 'SPACER', 'SOCIAL'];

class ColumnItemPlaceholder extends Component {
    addItem = (itemType) => {
        const { blockIndex, columnIdx, dispatch } = this.props;
        dispatch(
            columnItemActions.addNewColumnItem({
                blockIndex,
                columnIdx,
                itemType,
            })
        );
    };

    render() {
        const {
            blockIndex,
            columnIdx,
            canvasBlocks,
            dispatch,
            session,
            elementsModal: { location, status },
        } = this.props;
        const isFirstBlock = canvasBlocks[0].index === blockIndex;
        const displayElementModal = status && location.columnIdx === columnIdx;
        const allowSurvey = getSurveyPermission(session);
        if (!allowSurvey) {
            elementsArray = elementsArray.filter((element) => element !== elementTypes.SURVEY);
        }

        const addElement = () => {
            dispatch(
                modalActions.setModal({
                    name: 'elementsModal',
                    status: !displayElementModal,
                    location: displayElementModal ? null : { blockIndex, columnIdx },
                })
            );
        };

        return (
            <Styled.PlaceholderDiv>
                <Borders />
                <Styled.ItemDiv>
                    <Styled.IconSpan>
                        <Styled.Icon
                            displayElementModal={displayElementModal}
                            className="material-icons"
                            role="button"
                            tabIndex="0"
                            aria-label="add element"
                            onClick={addElement}
                            onKeyDown={(e) => handleKeyPress(e, addElement)}
                        >
                            add_circle
                        </Styled.Icon>
                    </Styled.IconSpan>
                    <Styled.ColumnElementWrapper
                        isFirstBlock={isFirstBlock}
                        openModalBelow={
                            window.innerWidth < 1450 && canvasBlocks[0].content.columns[0].columnIdx === columnIdx
                        }
                        className={displayElementModal ? 'open' : 'close'}
                    >
                        {elementsArray.map((element) => (
                            <ElementIcon
                                element={element}
                                key={element}
                                borderColor={elementBorderColors[element]}
                                isEnabled={element !== elementTypes.VIDEO || session.features.F_ELEMENT_VIDEO} // only video could be disabled in the preview
                                onClick={(event) => {
                                    event.stopPropagation();
                                    ReactTooltip.hide();
                                    this.addItem(element);
                                    dispatch(
                                        modalActions.setModal({
                                            name: 'elementsModal',
                                            status: false,
                                            location: null,
                                        })
                                    );
                                }}
                            />
                        ))}
                    </Styled.ColumnElementWrapper>
                </Styled.ItemDiv>
                <ColumnItemPlaceholderDropZone blockIndex={blockIndex} columnIdx={columnIdx} />
            </Styled.PlaceholderDiv>
        );
    }
}

const mapStateToProps = (state) => ({
    canvasBlocks: state.canvasBlocks.present,
    elementsModal: state.modals.elementsModal,
    session: state.session,
});

ColumnItemPlaceholder.propTypes = {
    dispatch: PropTypes.func.isRequired,
    blockIndex: PropTypes.string.isRequired,
    columnIdx: PropTypes.string.isRequired,
    canvasBlocks: PropTypes.arrayOf(blockType).isRequired,
    elementsModal: PropTypes.object.isRequired,
    session: sessionType.isRequired,
};

export default connect(mapStateToProps)(ColumnItemPlaceholder);
